'use client'
import { useState } from 'react'
import { Button, ButtonProps } from './button'

type Props = ButtonProps & {
  copyLink: 'currentLink' | string
}

export const CopyButton: React.FC<Props> = ({
  children,
  className = '',
  copyLink,
  ...rest
}) => {
  const [tooltip, setTooltip] = useState('Copy to Clipboard')
  const handleCopyLink = () => {
    if (copyLink === 'currentLink') {
      navigator.clipboard.writeText(location.origin)
    } else {
      navigator.clipboard.writeText(copyLink)
    }
    setTooltip('Copied!')
    setTimeout(() => setTooltip('Copy to Clipboard'), 2000)
  }

  return (
    <div className='group relative'>
      <Button
        className={className}
        onClick={handleCopyLink}
        onMouseEnter={() => setTooltip('Copy to Clipboard')}
        {...rest}
      >
        {children}
        <span className='invisible absolute top-full z-20 mt-1 rounded bg-gray-200 px-2 py-1 text-sm text-black opacity-0 transition-all group-hover:visible group-hover:opacity-100'>
          {tooltip}
        </span>
      </Button>
    </div>
  )
}
